import { render } from "./KidsStore.vue?vue&type=template&id=30a0c82f&scoped=true"
import script from "./KidsStore.vue?vue&type=script&lang=js"
export * from "./KidsStore.vue?vue&type=script&lang=js"

import "./kidsStore.css?vue&type=style&index=0&id=30a0c82f&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a0c82f"]])

export default __exports__